import { render, staticRenderFns } from "./BeefBasicSettingsPage.vue?vue&type=template&id=6bd24616&scoped=true"
import script from "./BeefBasicSettingsPage.vue?vue&type=script&lang=js"
export * from "./BeefBasicSettingsPage.vue?vue&type=script&lang=js"
import style0 from "./BeefBasicSettingsPage.vue?vue&type=style&index=0&id=6bd24616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd24616",
  null
  
)

export default component.exports